var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    transform: "translate(8353 845)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(-8353 -845)",
    fill: "#ae9c84",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-card_payment",
    d: "M8.848,4A1.744,1.744,0,0,0,7.1,5.744v.872H19.313V5.744A1.744,1.744,0,0,0,17.569,4ZM7.1,8.36v3.488a1.729,1.729,0,0,0,.329,1.012L11.386,10.4a1.745,1.745,0,0,1,2.3.405l.635.814a3.016,3.016,0,0,1,.627,1.976h2.623a1.744,1.744,0,0,0,1.744-1.744V8.36Zm-2.836.08a1.038,1.038,0,0,0-.55.187L1.749,10A1.741,1.741,0,0,0,1,11.428V17.08a1.744,1.744,0,0,0,1.744,1.744H7.612a2.921,2.921,0,0,0,2.43-1.3l2.931-3.3a1.274,1.274,0,0,0-.029-1.533.938.938,0,0,0-1.48-.288L7.63,14.793a1.485,1.485,0,0,1-2.27-1.26V9.486A1.046,1.046,0,0,0,4.268,8.44Z",
    transform: "translate(-8348.156 -841.412)",
    fill: "#655a4e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon1);
export default __webpack_public_path__ + "static/media/PaymentIcon1.23e6d89377956a77959d08b86485bdc6.svg";
export { ForwardRef as ReactComponent };